import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'

import Checkbox from '../components/psc/lib/Checkbox'

import useAuthentication from '../hooks/useAuthentication';
import useUserManagement from '../hooks/useUserManagement';
import useBrowserTabTitle from '../hooks/useBrowserTabTitle';

const CompanySignup = () => {
    useBrowserTabTitle('Company Signup')

    const navigate = useNavigate();
    
    const {
        currentUser,
        updateUser,
    } = useAuthentication();

    const {
        userShowNavigation
    } = useUserManagement()

    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
    const [error, setError] = useState(false);
    const [hasAgreed, setHasAgreed] = useState(false);
    const [companyName, setCompanyName] = useState('');
    const [companyNumber, setCompanyNumber] = useState('');
    const [companyCountry, setCompanyCountry] = useState('');
    const [adminName, setAdminName] = useState('');
    const [adminRole, setAdminRole] = useState('');
    const [adminEmail, setAdminEmail] = useState('');
    const [accountingName, setAccountingName] = useState('');
    const [accountingEmail, setAccountingEmail] = useState('');

    useEffect(() => {
        if (!currentUser) {
            navigate('/login');
            return;
        }
        if (userShowNavigation(currentUser)) {
            navigate('/main');
            return;
        }
    }, [currentUser, navigate]);

    const validateForm = () => {
        if (companyName === '') return false;
        if (companyNumber === '') return false;
        if (companyCountry === '') return false;
        if (adminName === '') return false;
        if (adminRole === '') return false;
        if (adminEmail === '') return false;
//        if (accountingName === '') return false;
//        if (accountingEmail === '') return false;
        if (!hasAgreed) return false;
        return true;
    };

    useEffect(() => {
        setIsSubmitDisabled(!validateForm());
    }, [companyName, companyNumber, companyCountry, adminName, adminRole, adminEmail, hasAgreed]);
//}, [companyName, companyNumber, companyCountry, adminName, adminRole, adminEmail, accountingName, accountingEmail, hasAgreed]);

    const handleChange = (event) => {
        const key = event.target.name;
        const value = event.target.value;

        if (key === 'has_agreed') {
            setHasAgreed(!hasAgreed);
        } else {
            const trimmedValue = key.match(/email$/) ? value.trim() : value;
            switch(key) {
                case 'company_name': setCompanyName(trimmedValue); break;
                case 'company_number': setCompanyNumber(trimmedValue); break;
                case 'company_country': setCompanyCountry(trimmedValue); break;
                case 'admin_name': setAdminName(trimmedValue); break;
                case 'admin_role': setAdminRole(trimmedValue); break;
                case 'admin_email': setAdminEmail(trimmedValue); break;
                case 'accounting_name': setAccountingName(trimmedValue); break;
                case 'accounting_email': setAccountingEmail(trimmedValue); break;
                default: break;
            }
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        if (!hasAgreed) {
            console.log("Has not checked the box");
            setError(true);
            return;
        }

        setError(false);
        
        const formData = {
            has_agreed: hasAgreed,
            company_name: companyName,
            company_number: companyNumber,
            company_country: companyCountry,
            admin_name: adminName,
            admin_role: adminRole,
            admin_email: adminEmail,
            accounting_name: accountingName,
            accounting_email: accountingEmail
        };

        fetch('/v0/account/agree_toc', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(res => res.json())
        .then(json => {
            updateUser(json.result);
            navigate('/main');
        })
        .catch(() => {
            setError(true);
        });
    };

    const submitButton = 
        isSubmitDisabled
        ? ( <button className="btn btn-disabled btn-mr" type="submit" disabled>Sign Up Now!</button> )
        : ( <button className="btn btn-primary btn-mr" type="submit">Sign Up Now!</button> )

    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">

                            <h2>GNC Go New Account Sign-up</h2>
                            
                        </div>
                        <div className="ibox-content">
                            <form className="form-horizontal" onSubmit={handleSubmit}>
                                
                                <div className="form-group">
                                    <label className="col-sm-2"></label>
                                    <div className="col-sm-8">
                                        <h3>Your Starting Package</h3>
                                        <p>SME Space Heroes - 30 Users [3-Month FREE Trial]</p>
                                        <p>
                                            <a href="https://gncgo.space/legal/sla-sme-space-heroes-insider/" target="_blank" rel="noreferrer"> Service Level Agreement (SLA) - SME Space Heroes - Insider </a>
                                        </p>
                                    </div>
                                </div>
                                
                                <div className="form-group">
                                    <label className="col-sm-2"></label>
                                    <div className="col-sm-8">
                                        <h3>Your Organisation</h3>
                                    </div>
                                </div>
                                
                                <div className="form-group">
                                    <label className="col-sm-2 control-label">Company Name
                                    </label>
                                    <div className="col-sm-8">
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="company_name"
                                            value={companyName}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="col-sm-2 control-label">Company Number
                                    </label>
                                    <div className="col-sm-8">
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="company_number"
                                            value={companyNumber}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="col-sm-2 control-label">Country of Incorporation
                                    </label>
                                    <div className="col-sm-8">
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="company_country"
                                            value={companyCountry}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="col-sm-2"></label>
                                    <div className="col-sm-8">
                                        <h3>Your Account Administrator (Admin)</h3>
                                        <p>Your contact for account administration and notices.</p>
                                    </div>
                                </div>
                                
                                <div className="form-group">
                                    <label className="col-sm-2 control-label">Your Name
                                    </label>
                                    <div className="col-sm-8">
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="admin_name"
                                            value={adminName}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="col-sm-2 control-label">Your Role
                                    </label>
                                    <div className="col-sm-8">
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="admin_role"
                                            value={adminRole}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="col-sm-2 control-label">Your Email
                                    </label>
                                    <div className="col-sm-8">
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="admin_email"
                                            value={adminEmail}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="col-sm-2"></label>
                                    <div className="col-sm-8">
                                        <h3>Your Accounts Team</h3>
                                        <p>Your contact for invoicing and payments (Not required for FREE Sandbox Trial).</p>
                                    </div>
                                </div>
                                
                                <div className="form-group">
                                    <label className="col-sm-2 control-label">Accounts Name
                                    </label>
                                    <div className="col-sm-8">
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="accounting_name"
                                            value={accountingName}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="col-sm-2 control-label">Accounts Email
                                    </label>
                                    <div className="col-sm-8">
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="accounting_email"
                                            value={accountingEmail}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>

                                <div className="hr-line-dashed"></div>
                                
                                <div className="form-group">
                                    <label className="col-sm-2"></label>
                                    <div className="col-sm-8">
                                        <p><label>
                                            Before signing up please make sure that you have read and understood our Terms of Use, Service Level Agreement (SLA), Privacy Policy and Cookie Policy.
                                        </label></p>

                                        <Checkbox
                                            id="has_agreed"
                                            name="has_agreed"
                                            onChange={handleChange}
                                            isChecked={hasAgreed}
                                        />

                                        <label style={{display: 'inline', fontWeight: 'normal', paddingLeft: '10px'}}>
                                            I have read and accept the
                                            <a href="https://gncgo.space/legal/terms/" target="_blank" rel="noreferrer"> GNC Go Terms of Use </a>
                                            and
                                            <a href="https://gncgo.space/legal/sla-sme-space-heroes-insider/" target="_blank" rel="noreferrer"> Service Level Agreement (SLA) - SME Space Heroes - Insider </a>
                                            , and I have read and understood the 
                                            <a href="https://gncgo.space/privacy/privacy-policy/" target="_blank" rel="noreferrer"> Privacy Policy </a> and
                                            <a href="https://gncgo.space/privacy/cookie-policy/" target="_blank" rel="noreferrer"> Cookie Policy </a>.
                                        </label>
                                    </div>
                                </div>
                                
                                <div className="hr-line-dashed"></div>
                                
                                {error && <div className="alert alert-danger">You have to accept the Terms</div>}
                                
                                <div className="form-group">
                                    <div className="col-sm-8 col-sm-offset-2">
                                        {submitButton}
                                    </div>
                                </div>
                                
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default CompanySignup;
